import axios from 'axios'
import Config from "./config";
import {Auth} from "@aws-amplify/auth";
import * as actions from "../store/actions";

const baseURL = Config.STIMULUS_URL;
const staticToken = Config.STIMULUS_REGISTERATION_TOKEN;

const getNewToken = async () => {
  try {
    const currentSession: any = await Auth.currentSession();
    const cognitoUser = await Auth.currentAuthenticatedUser();
    return new Promise((resolve) =>
      cognitoUser.refreshSession(currentSession.refreshToken, async (err: any, session: any) => {
        if (err) {
          actions.logoutUserSuccess();
          localStorage.clear();
          await Auth.signOut();
          await cognitoUser.signOut();
          window.location.replace("/user/login")
        } else {
          const { idToken, accessToken } = session;
          localStorage.setItem("auth_token", accessToken['jwtToken']);
          localStorage.setItem("idToken", idToken['jwtToken']);
          resolve({
            newAccessToken: accessToken['jwtToken'],
            newIdToken: idToken['jwtToken']
          });
        }
      }));
  } catch (e) {
    localStorage.clear();
    window.location.replace("/user/login")
  }
};

export const apiClient = (stimulusAPI: boolean) => {
  const idToken = localStorage.getItem("idToken") ? localStorage.getItem("idToken") : "";
  const instance = axios.create({
    baseURL: baseURL,
    withCredentials: false,
    headers: {
      Accept: '*/*',
      Authorization: stimulusAPI ? (idToken ? `Bearer ${idToken}` : null) : `Bearer ${staticToken}`
    }
  });
  if (stimulusAPI) {
    instance.interceptors.response.use((response) => {
      return response;
    }, async (error) => {
      const originalRequest = error.config;
      if (error?.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        const res: any = await getNewToken();
        originalRequest.headers.Authorization = 'Bearer ' + res.newIdToken;
        return instance(originalRequest);
      }
      return Promise.reject(error);
    });
  }
  return instance;
};